import React from 'react'
import Media from 'react-media';

import LangMenu from '../langMenu/langMenu.js'
import logo from '../../images/logo.svg'
import headerStyles from './header.module.scss'


const Header = (props) => {
    return (
        <header className={headerStyles.header}>
            <img className={headerStyles.logo} src={logo} alt="Semograph"/>
            <LangMenu location={props.location}/>
        </header>
    )
};

export default Header;